import Backbone from 'backbone';
import i18n from '../utils/i18n';

const SearchSubmenu = Backbone.View.extend({
  id: 'search-nav',
  i18n: new i18n(),
  disabledColorClass: '$color/alpha:54%',
  events: {
    'input [data-search-input]':  'onInputChange',
    'click [data-search-submit]': 'onClickSubmit',
  },
  initialize() {
    this.wrapper          = this.$('[data-search-wrapper]')[0];
    this.input            = this.$('[data-search-input]')[0];
    this.submitButtonHint = this.$('[data-search-hint]')[0];
    this.submitButton     = this.$('[data-search-submit]')[0];
    this.listenTo(Backbone, {
      'primary-nav:submenu:opened':  this.onOpen,
      'primary-nav:submenu:close':   this.onClose
    });
  },
  setActive() {
    this.wrapper.classList.remove(this.disabledColorClass);
    this.submitButton.setAttribute('aria-disabled', false);
    this.submitButton.classList.remove(this.disabledColorClass);
    this.submitButtonHint.textContent = this.i18n.t('global__main_nav__search__accessibility-hint__search');
  },
  setInactive() {
    this.wrapper.classList.add(this.disabledColorClass);
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add(this.disabledColorClass);
    this.submitButtonHint.textContent = this.i18n.t('global__main_nav__search__accessibility-hint__enter-a-term-to-search');
  },
  onOpen(eventData) {
    if (hasOwnProperty.call(eventData, 'activeSubmenuId') && (eventData.activeSubmenuId === this.id)) this.input.focus();
  },
  onClose() {
    this.input.value = '';
    this.setInactive();
  },
  onInputChange(e) {
    if (e?.target?.value !== '') {
      this.setActive();
    } else {
      this.setInactive();
    }
  },
  onClickSubmit(e) {
    e.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') { return; }

    this.$el.submit();
  },
  dispose() {
    this.undelegateEvents();
    this.stopListening();
  },
});

export default SearchSubmenu;
